
import {Component, Inject, OnInit, DOCUMENT} from '@angular/core';
import {RoutingService, WindowRef} from '@spartacus/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {AimoRoutingService} from '../../../cms-structure/routing/aimo-routing.service';
import {AimoUserService} from '../../../service/user/aimo-user.service';
import {AimoAuthService} from "../../../service/auth/aimo-auth.service";

@Component({
    selector: 'aimo-cx-login',
    templateUrl: './aimo-login.component.html',
    standalone: false
})
export class AimoLoginComponent implements OnInit {
    loggedIn$: Observable<boolean>;
    notLoggedIn$: Observable<boolean>;

    constructor(
        protected auth: AimoAuthService,
        protected userService: AimoUserService,
        protected aimoRoutingService: AimoRoutingService,
        protected winRef: WindowRef,
        protected routingService: RoutingService,
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    ngOnInit(): void {
        this.loggedIn$ = this.auth.isUserLoggedIn();
        this.notLoggedIn$ = this.loggedIn$.pipe(map((l) => l === false));
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    isOnUrlPage(url: string): void {
        if (typeof url === 'string' && this.document.defaultView.window?.location.href.includes(url)) {
            this.document.location.reload();
        } else {
            this.auth.forwardToCDCLoginPage(false);
           // this.routingService.go('/login')
        }
    }
}
